
<template>
  <div v-if="formatter.config" :key="'geoFormatter-' + reload">
    <div class="agInputGroup agInputGroupCentered">
      <label>Shape:</label>
      <b-form-select
        class="agMediumInput"
        v-model="shape"
        :options="shapes"
        :disabled="disableUI">
      </b-form-select>
    </div>
    <div v-if="shape == 'point'">
      <div class="agInputGroup agInputGroupCentered">
        <div class="agInputGroup agInputGroupInline">
            <label>X:</label>
            <ag-input-select
                :key="'xReload - ' + reload"
                :useSubInput="true"
                :inputModel="x.value"
                :selectModel="x.field"
                :workflow="workflow"
                :groups="fields"
                :width="400"
                :disabled="disableUI"
                @input_keyup="fieldInput_keyup($event, 'x')"
                @select_change="fieldSelect_change($event, 'x')">
            </ag-input-select>
        </div>
        <div class="agInputGroup agInputGroupInline">
            <label>Y:</label>
            <ag-input-select
                :key="'yReload - ' + reload"
                :useSubInput="true"
                :inputModel="y.value"
                :selectModel="y.field"
                :workflow="workflow"
                :groups="fields"
                :width="400"
                :disabled="disableUI"
                @input_keyup="fieldInput_keyup($event, 'y')"
                @select_change="fieldSelect_change($event, 'y')">
            </ag-input-select>
        </div>
      </div>
      <div class="agInputGroup agInputGroupCentered">
        <div class="agInputGroup agInputGroupInline">
            <label>Z:</label>
            <ag-input-select
                :key="'zReload - ' + reload"
                :useSubInput="true"
                :inputModel="z.value"
                :selectModel="z.field"
                :workflow="workflow"
                :groups="fields"
                :width="400"
                :disabled="disableUI"
                @input_keyup="fieldInput_keyup($event, 'z')"
                @select_change="fieldSelect_change($event, 'z')">
            </ag-input-select>
        </div>
        <div class="agInputGroup agInputGroupInline">
            <label>M:</label>
            <ag-input-select
                :key="'mReload - ' + reload"
                :useSubInput="true"
                :inputModel="m.value"
                :selectModel="m.field"
                :workflow="workflow"
                :groups="fields"
                :width="400"
                :disabled="disableUI"
                @input_keyup="fieldInput_keyup($event, 'm')"
                @select_change="fieldSelect_change($event, 'm')">
            </ag-input-select>
        </div>
      </div>
      <div class="agInputGroup agInputGroupCentered">
          <label>Spatial Ref (wkid):</label>
          <ag-input-select
              :key="'srReload - ' + reload"
              :useSubInput="true"
              :inputModel="spatialRef.value"
              :selectModel="spatialRef.field"
              :workflow="workflow"
              :groups="fields"
              :width="225"
              :disabled="disableUI"
              @input_keyup="fieldInput_keyup($event, 'spatialRef')"
              @select_change="fieldSelect_change($event, 'spatialRef')">
          </ag-input-select>
      </div>
    </div>
  </div>
</template>






<script>
// components
import InputSelect from "comp/ui/InputSelect";

// modules
import Util from "src/util/util";

export default {
  name: "ag-geoFormatter",
  components: {
    "ag-input-select": InputSelect
  },
  props: {
    disableUI: Boolean,
    formatter: Object,
    workflow: Object,
  },
  data() {
    return {
        reload: 0,
        shape: "",
        shapes: [
          { value: "point", text: "Point" }
        ],
        fields: [],
        x: {field: null, value: null},
        y: {field: null, value: null},
        z: {field: null, value: null},
        m: {field: null, value: null},
        spatialRef: {field: null, value: null}
    };
  },
  computed: {},
  watch: {},

  created() {},

  mounted() {
    this.reset();
  },

  methods: {
    // UI Events

     fieldInput_keyup(value, field) {
       this[field].value = value;
       this[field].field = null;
    },

    fieldSelect_change(value, field) {

      if(value.field == "-- None --") {
        this[field].value = null;
        this[field].field = null;
        this.reload++;
        return;
      }
      this[field].value = null;
      this[field].field = value;
    },

    // emitted Events

    // other

    reset() {
      if(this.formatter.config) {
        this.shape = this.formatter.config.shape;
        if(this.formatter.config.x)
          this.x = this.formatter.config.x;
        if(this.formatter.config.y)
          this.y = this.formatter.config.y;
        if(this.formatter.config.z)
          this.z = this.formatter.config.z;
        if(this.formatter.config.m)
          this.m = this.formatter.config.m;
        if(this.formatter.config.spatialRef)
          this.spatialRef = this.formatter.config.spatialRef;
      }
      this.setFields();
      this.reload++;
    },

    prepareForSave() {

      this.formatter.config = {};
      this.formatter.config.shape = this.shape;

      if(this.x.field || this.x.value) {
        this.formatter.config.x = this.x;
      }
      if(this.y.field || this.y.value) {
        this.formatter.config.y = this.y;
      }
      if(this.z.field || this.z.value) {
        this.formatter.config.z = this.z;
      }
      if(this.m.field || this.m.value) {
        this.formatter.config.m = this.m;
      }
      if(this.spatialRef.field || this.spatialRef.value) {
        this.formatter.config.spatialRef = this.spatialRef;
      }
    },

    setFields() {
      // add -- None -- to be able to blank out fields
      this.fields = {
        " ": [{
            value: { object: "", field: "-- None --" },
            text: "-- None --"
      }]};
      var inputFields = Util.getInputFields(this.$store, this.workflow);
      var optionGroups = Util.fieldsToOptionGroups(inputFields);
      Object.assign(this.fields, optionGroups);
    },
  }
};
</script>






<style scoped lang="css">
</style>



// WEBPACK FOOTER //
// src/components/nodes/formatters/GeoFormatter.vue